import { BillSource } from "@app/products-base";
import { IEntity, minLength, prop, required } from "@messaia/cdk";

export class BillBundleCancellation implements IEntity {
    @prop()
    id: number;

    @required()
    reason: string;

    @required()
    @minLength({ value: 1 })
    billSources: BillSource[];

    @prop()
    date: Date;
}